module.exports = __webpack_public_path__ + "img/loading_fangkuai.fd0365ab.png";